<div class="container-tab-lists new-table-style">
  <div style="display:flow-root">
    <div style="float:left; width:40vw">
      <h2>Measure Plan</h2>
    </div>
  </div>
  <mat-tab-group mat-stretch-tabs="false" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" #tabGroup>
    <mat-tab label="Measure Definition">
      <div class="inner-tcontainer-tab">
        <div style="display:flow-root">
          <div style="text-align:left; float:left; margin-top: 1em;">
            <h5 class="salmon-color">{{minMeasuresWarning}}</h5>
            <h5 class="salmon-color">{{minActionItemsWarning}}</h5>
          </div>
          <div style="text-align:right; float:right">

            @if (showSaveButton() && canEdit()) {
              <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
                <span class='glyphicon glyphicon-floppy-disk'></span> Save
              </a>
            }
            @if (canEdit()) {
              <excelbuttons [downloadConfig]="excelDownloadConf" [uploadConfig]="excelUploadConf"></excelbuttons>
            }

            @if (canEdit()) {
              <a class="kpi-button-menu"
                [title]="canAddNewMeasure() ? 'Create measure' : 'Max Measure items limit reached'"
                (click)="openCreateMeasurePopup()"
                [class.disabled-link-looking]="!canAddNewMeasure()"
                >
                <span class="glyphicon glyphicon-plus"></span> Create
              </a>
            }


          </div>
        </div>
        <br />
        <focusplan-list #focusPlanList
          [measuresInfo]="measuresInfo"
          [waveId]="waveId"
        (refresh)="onRefreshPending()"></focusplan-list>
      </div>
    </mat-tab>
    <mat-tab label="Financial Impact">
      <div class="inner-tcontainer-tab">
        <div style="text-align:right; float:right; padding: 1%">

          @if (isEditModeEnabled && canEdit()) {
            <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
              <span class='glyphicon glyphicon-floppy-disk'></span> Save
            </a>
          }

          @if (canEdit()) {
            <excelbuttons [downloadConfig]="excelDownloadFinancialImpactConf" [uploadConfig]="excelUploadFinancialImpactConf"></excelbuttons>
          }

          @if (canEdit()) {
            <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
              <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
            </a>
          }

          <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
            Edit Mode is enabled. Please click on Save button to save all changes
            / <span style="color: #77DD77;">% KPI figures must be between -1 and 1.</span>
          </h5>
        </div>
        <br />
        <focusplanimpact-list #focusPlanListImpact
          [measureImpactsInfo]="measureImpactsInfo"
          [isEditModeEnabled]="isEditModeEnabled"
          [waveId]="waveId"
          [fiscalYear]="fiscalYear"
        (refresh)="onRefresh()"></focusplanimpact-list>
      </div>
    </mat-tab>
    <mat-tab label="Status">
      <div class="inner-tcontainer-tab">
        <div class="status-description-div col-md-6">
          <p class="status-description"><strong>Overdue:</strong> The action item has not been started and there is a risk of not meeting the deadline.</p>
          <p class="status-description"><strong>At Risk:</strong> The action item is delayed and unlikely to be completed by the deadline.</p>
          <p class="status-description"><strong>On Track:</strong> The action item is in progress and expected to be completed by the deadline.</p>
          <p class="status-description"><strong>Completed:</strong> The action item has been implemented and is operational.</p>
        </div>

        <div style="text-align: right; float: right; padding: 1%" class="col-md-6">

          @if (!isExcelModeEnabled && !isEditModeEnabled && canEdit()) {
            <a class='kpi-button-menu' title="Excel" (click)="onClickExcel()">
              Excel
            </a>
          }

          @if (isExcelModeEnabled) {
            <a class='kpi-button-menu' title="Dowload" (click)="onClickDownload()">
              <span class='glyphicon glyphicon-download'></span> Download
            </a>
          }

          @if (isExcelModeEnabled) {
            <a class='kpi-button-menu' title="Upload" (click)="onClickUpload()">
              <span class='glyphicon glyphicon-upload'></span> Upload
            </a>
          }

          @if (isExcelModeEnabled) {
            <a class='kpi-button-menu' title="Excel" (click)="onClickExitExcel()">
              Exit Excel Mode
            </a>
          }

          @if (isEditModeEnabled) {
            <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
              <span class='glyphicon glyphicon-floppy-disk'></span> Save
            </a>
          }

          @if (canEdit()) {
            <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
              <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
            </a>
          }

          <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
            Edit Mode is enabled. Please click on Save button to save all changes
          </h5>
        </div>
        <br />
        <focusplanstatus-list #focusPlanListStatus
          [measuresInfo]="measuresInfo"
          [isEditModeEnabled]="isEditModeEnabled"
          [waveId]="waveId"
          [statusesQX]="statusesQX"
        (refresh)="onRefresh()"></focusplanstatus-list>
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
